import React, { useContext } from "react"
import { PCViewContext } from "../Common/PCViewContext"
import * as styles from "./Styles/Footer.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import logo from "../../images/logo_white.png"

const Inquiry = () => {
  return <a href="mailto:locoguide-support@locoguide.co.jp">お問い合わせ</a>
}
const Term = () => {
  return (
    <a href="https://static.tokubai.co.jp/terms/locoguide.html" target="_blank">
      サービス利用規約
    </a>
  )
}
const Privacy = () => {
  return (
    <a
      href="https://static.tokubai.co.jp/terms/tokubai_app_privacy.html"
      target="_blank"
    >
      個人情報保護方針
    </a>
  )
}
const Company = () => {
  return (
    <a href="https://locoguide.co.jp" target="_blank">
      運営会社
    </a>
  )
}

const Footer = () => {
  const isPC = useContext(PCViewContext)

  return (
    <div className={styles.container}>
      {isPC && (
        <div className={styles.pcLinks}>
          {[Inquiry, Term, Privacy, Company].map((Component, i) => (
            <React.Fragment key={i}>
              <div>
                <Component />
              </div>
              {i != 3 && <div className={styles.separator} />}
            </React.Fragment>
          ))}
        </div>
      )}
      {!isPC && (
        <React.Fragment>
          <div className={cn("l-flex", "col")}>
            <div className={cn("l-flex", "l-flex-align-center", "row")}>
              <Inquiry />
            </div>
            <div className={cn("l-flex", "l-flex-align-center", "row")}>
              <Term />
            </div>
          </div>
          <div className={cn("l-flex", "col")}>
            <div
              className={cn(
                "l-flex",
                "l-flex-align-center",
                "row",
                "row--last"
              )}
            >
              <Privacy />
            </div>
            <div
              className={cn(
                "l-flex",
                "l-flex-align-center",
                "row",
                "row--last"
              )}
            >
              <Company />
            </div>
          </div>
        </React.Fragment>
      )}

      <div className={styles.logo}>
        <a href="/">
          <img src={logo}></img>
        </a>
      </div>
      <div className={styles.copyright}>© 2020 Locoguide Inc.</div>
    </div>
  )
}

export default Footer
